

// mapbox
mapboxgl.accessToken = 'pk.eyJ1Ijoic25vd3dhbGsiLCJhIjoiY2o4ZGp3OGNkMHBtcjMzbXN6d2dreG1neCJ9.hX7eYVtleEwwdgArnZqQ_w';
var map = new mapboxgl.Map({
	container: 'map', // container id
	style: 'mapbox://styles/mapbox/light-v9',
	center: [20.61275, 52.3196],
	zoom: 11
});

var tracks = [
	{
		"id": "01",
		"data": require("../dist/geojson/snowwalk_trail01.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "02",
		"data": require("../dist/geojson/snowwalk_trail02.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "03",
		"data": require("../dist/geojson/snowwalk_trail03.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "04",
		"data": require("../dist/geojson/snowwalk_trail04.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "05",
		"data": require("../dist/geojson/snowwalk_trail05.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "06",
		"data": require("../dist/geojson/snowwalk_trail06.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "07",
		"data": require("../dist/geojson/snowwalk_trail07.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "08",
		"data": require("../dist/geojson/snowwalk_trail08.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "09",
		"data": require("../dist/geojson/snowwalk_trail09.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "10",
		"data": require("../dist/geojson/snowwalk_trail10.geojson"),
		"category": "trail",
		"level": "easy",
		"paint": {
			"line-color": "#a3ec16",
			"line-width": 3
		}
	},
	{
		"id": "11",
		"data": require("../dist/geojson/snowwalk_trail11.geojson"),
		"category": "trail",
		"level": "easy",
		"paint": {
			"line-color": "#a3ec16",
			"line-width": 3
		}
	},
	{
		"id": "12",
		"data": require("../dist/geojson/snowwalk_trail12.geojson"),
		"category": "trail",
		"level": "easy",
		"paint": {
			"line-color": "#a3ec16",
			"line-width": 3
		}
	},
	{
		"id": "13",
		"data": require("../dist/geojson/snowwalk_trail13.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "14",
		"data": require("../dist/geojson/snowwalk_trail14.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "15",
		"data": require("../dist/geojson/snowwalk_trail15.geojson"),
		"category": "trail",
		"level": "strong",
		"paint": {
			"line-color": "#ffa700",
			"line-width": 3
		}
	},
	{
		"id": "16",
		"data": require("../dist/geojson/snowwalk_trail16.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "17",
		"data": require("../dist/geojson/snowwalk_trail17.geojson"),
		"category": "trail",
		"level": "extreme",
		"paint": {
			"line-color": "#f2009b",
			"line-width": 3
		}
	},
	{
		"id": "trails",
		"data": require("../dist/geojson/snowwalk_trails.geojson"),
		"category": "trail",
		"layout": {
			"line-join": "round",
			"line-cap": "round",
			"visibility": "visible"
		},
		"paint": {
			"line-color": "#3887be"
		}
	},
	{
		"id": "CP",
		"data": require("../dist/geojson/snowwalk_checkpoints.geojson"),
		"category": "poi",
		"type": "symbol",
		"layout": {
			"icon-image": "{icon}-15",
			"text-field": "{name}",
			"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
			"text-size": 10,
			"text-offset": [0, 0.6],
			"text-anchor": "top",
			"visibility": "none"
		}
	},
	{
		"id": "starts",
		"data": require("../dist/geojson/snowwalk_starts.geojson"),
		"category": "poi",
		"type": "symbol",
		"layout": {
			"icon-image": "{icon}-stroked-15",
			"icon-allow-overlap": true,
			"text-field": "{name}",
			"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
			"text-size": 8,
			"text-offset": [0, 0.9],
			"text-anchor": "top",
			"visibility": "visible"
		}
	}
];

map.on('load', function () {
	for(var i=0; i<tracks.length; i++)
	{
		var row = tracks[i];
		map.addSource(row.id, {
			"type": "geojson",
			"data": row.data
		});
	}

	// ikona start
	// map.loadImage('/test/img/cpstartico.png', function(error, image) {
	// 		if (error) throw error;
	// 	map.addImage('start', image);
	// })


	for(var i in tracks)
	{
		var trail = tracks[i];
		map.addLayer(
		{
			"id": trail.id,
			"source": trail.id,
			"type": trail.type ? trail.type : "line",
			"layout": trail.layout ? trail.layout : {
				"line-join": "round",
				"line-cap": "round",
				'visibility': 'none'
			},
			paint: {
				// "line-width": 1,
				...trail.paint
			}
		});

		var link = document.createElement('a');
		link.href = '#';
		link.textContent = trail.id;
		link.index = i;
		link.className = trail.level ? 'grad-'+trail.level : "active";

		if(trail.layout && trail.layout.visibility == 'visible')
		{
			link.classList.add('click')
		}

		link.onclick = function (e) {
			$(e.currentTarget).toggleClass('click')
			var clickedLayer = this.textContent;
			e.preventDefault();
			e.stopPropagation();

			var index = $(this)[0].index
			var track = tracks[index]
			if($(e.currentTarget).hasClass('click') && track.level)
			{
				map.flyTo({
					center: track.data.features[0].geometry.coordinates[0],
					zoom: 12,
					speed: 0.6
				});
			}
			var id = track.id

			window.clicked = map.getSource(id)

			var visibility = map.getLayoutProperty(clickedLayer, 'visibility');

			if (visibility === 'visible') {
				map.setLayoutProperty(clickedLayer, 'visibility', 'none');
				// this.className = '';

			} else {
				// this.className = 'active';
				map.setLayoutProperty(clickedLayer, 'visibility', 'visible');
			}
		};

		var layers = document.getElementById('menu');
		layers.appendChild(link);
	}

	// setTimeout(function(){
	   //  $('#menu #starts').addClass('click')
	   //  map.setLayoutProperty("starts", 'visibility', 'visible');
	// }, 5000)
});


map.on('click', 'starts', function (e) {
    var coordinates = e.features[0].geometry.coordinates.slice();
    var description = e.features[0].properties.description;

    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(map);
    map.flyTo({
		center: coordinates,
		// zoom: 12,
		speed: 0.6
	});
});


// Change the cursor to a pointer when the mouse is over the places layer.
map.on('mouseenter', 'starts', function () {
    map.getCanvas().style.cursor = 'pointer';
});

// Change it back to a pointer when it leaves.
map.on('mouseleave', 'starts', function () {
    map.getCanvas().style.cursor = '';
});    


// Add full screen controls to the map.
map.addControl(new mapboxgl.FullscreenControl({container: document.querySelector('body')}));

// Add zoom and rotation controls to the map.
map.addControl(new mapboxgl.NavigationControl());

// disable map zoom when using scroll
map.scrollZoom.disable();

// Add geolocate control to the map.
map.addControl(new mapboxgl.GeolocateControl({
	positionOptions: {
		enableHighAccuracy: true
	},
	trackUserLocation: true
}));